import EventBus from "../../events/EventBus";
import { addGlobalLiveEventListener } from "../../utils";
import { useSetsApi } from "../user_sets/api";
let constructorStatus = 'create';
export function initConstructorCards() {
    addGlobalLiveEventListener('click', '.js-add-to-set', async (event) => {
        const button = event.target;
        const offerId = parseInt(button.getAttribute('data-offer-id'));
        handleAddToSetButtonClick(offerId, button, button.dataset.name || '');
    });
}
export async function handleAddToSetButtonClick(offerId, button, name) {
    if (!button || button.disabled) {
        return;
    }
    if (!offerId) {
        return;
    }
    const labelSpan = button.querySelector('.btn__label');
    const originalText = labelSpan ? labelSpan.textContent : 'В сет';
    try {
        button.disabled = true;
        const response = await useSetsApi().addItem(offerId);
        if (response.ok) {
            if (labelSpan) {
                labelSpan.textContent = 'Добавлено';
            }
            EventBus.emit('set:update', response.data);
            setTimeout(() => {
                if (constructorStatus !== 'full' && labelSpan && labelSpan.textContent === 'Добавлено') {
                    labelSpan.textContent = originalText;
                    button.disabled = false;
                }
            }, 1000);
        }
        else {
            if (response.error.limit) {
                EventBus.emit('set:replacement-requested', {
                    id: offerId,
                    name: name,
                });
            }
            else {
                console.warn(Object.values(response.error)[0] ?? 'Ошибка добавления');
                // TODO (toast): Показать ошибку добавления в сет (errorMessage)
            }
            if (constructorStatus !== 'full') {
                button.disabled = false;
            }
        }
    }
    catch (e) {
        console.error(e);
        // TODO (toast): Показать системную ошибку/сетевой сбой ('Произошла системная ошибка при добавлении в сет')
        if (constructorStatus !== 'full') {
            button.disabled = false;
        }
    }
}
export function lockAddToSetButtons(initialStatus) {
    function setButtonsDisabledState(isFull) {
        const buttons = document.querySelectorAll('.js-add-to-set');
        buttons.forEach((btn) => {
            const label = btn.querySelector('.btn__label');
            if (isFull) {
                btn.disabled = true;
                btn.classList.add('btn--gray');
                btn.classList.remove('btn--black');
                if (label) {
                    label.textContent = 'Лимит сетов';
                }
            }
            else {
                if (label && label.textContent === 'Лимит сетов') {
                    btn.disabled = false;
                    btn.classList.remove('btn--gray');
                    btn.classList.add('btn--black');
                    label.textContent = 'В сет';
                }
            }
        });
    }
    if (initialStatus) {
        constructorStatus = initialStatus;
    }
    // 1. Первоначальная установка при загрузке
    if (constructorStatus === 'full') {
        setButtonsDisabledState(true);
    }
    // 2. Обновление при изменении состава сета через EventBus
    EventBus.on('set:update', (data) => {
        if (data && data.status) {
            constructorStatus = data.status;
            setButtonsDisabledState(constructorStatus === 'full');
        }
    });
    // 3. Блокировка новых кнопок при AJAX-обновлении товаров (фильтры, пагинация)
    EventBus.on('products:load', () => {
        if (constructorStatus === 'full') {
            setButtonsDisabledState(true);
        }
    });
}
